export class MBulkGiftVoucherCustomer {
   indexNo: number;
   name: string;
}



// WEBPACK FOOTER //
// ./src/app/view/master-files/m-gift-voucher-bulk-customer/model/m-bulk-gift-voucher-customer-dto.ts